/**
 * Lab Automation app glyph — ported from ui_kits/lab-automation.
 * Uses currentColor, so it picks up the accent via parent styling.
 */
export interface LogoProps {
  size?: number;
  title?: string;
}

export function Logo({ size = 28, title = 'Lab Automation' }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      style={{ color: 'var(--accent)' }}
      role="img"
      aria-label={title}
    >
      <rect x="0.75" y="0.75" width="26.5" height="26.5" rx="5.25" fill="currentColor" fillOpacity="0.12"/>
      <rect x="0.75" y="0.75" width="26.5" height="26.5" rx="5.25" stroke="currentColor" strokeWidth="1.25"/>
      <path d="M6 15.5 L10 11 L14 15.5 L18.5 10" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      <circle cx="19.25" cy="18.75" r="2.6" fill="currentColor"/>
    </svg>
  );
}
